import { Component } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { CommonModule } from '@angular/common';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { NgToastService } from 'ng-angular-popup';
import { AuthenticationService } from '@/app/services/auth/authentication.service';
import { MatError, MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
@Component({
  standalone: true,
  imports: [ReactiveFormsModule, CommonModule, MatCheckboxModule, FormsModule, MatFormFieldModule,MatInputModule,MatError,MatIconModule],
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css'],
})
export class LoginComponent {
  viewPassword: boolean = false;
  form: FormGroup;
  isCheck = false;
  AuthenticationService: any;
  constructor(
    private fb: FormBuilder,
    private router: Router,
    private http: HttpClient,
    private toast: NgToastService,
    private authService: AuthenticationService
  ) {
    this.form = this.fb.group({
      email: ['', [Validators.required, Validators.email]],
      password: ['', [Validators.required, Validators.minLength(8)]],
    });
  }

  onSubmit() {
    if (this.form.valid) {
      const formData = this.form.value;
      this.authService.loginOrganization(formData).subscribe({
        next: (response: any) => {
          const { organizations, ...userInfo } = response.user;
          localStorage.setItem('buildxy-token', response.authorisation.token);
          localStorage.setItem('org_info', JSON.stringify(organizations[0]));
          localStorage.setItem('user_info', JSON.stringify(userInfo));
          this.toast.success('Login successfully', 'SUCCESS', 4000);
          this.form.reset();
          this.router.navigate(['/projects']);
        },
        error: (error: any) => {
          console.error('Login failed:', error);
          this.toast.danger(error.error.message, 'DANGER', 4000);
        },
      });
    } else {
      this.form.markAllAsTouched();
      console.log('Form is invalid');
    }
  }
  setIsCheck(value: boolean) {
    this.isCheck = value;
  }

  register() {
    this.router.navigate(['/register']);
    localStorage.removeItem('org_info');
  }
  navigateToRecoverAccount() {
    this.router.navigate(['/recover-account']);
  }
  navigateToDashbaord() {
    this.router.navigate(['/']);
  }
}
